export default __webpack_public_path__ + "static/media/question.9889585c.png";